/**
 * Le nom du produit — 06 §8, [DECISIONS §160].
 *
 * SOURCE UNIQUE. Le mot paraît dans le logotype, dans le titre de secours de
 * la coque, dans le préfixe des messages de console et dans les ressources
 * générées. Écrit huit fois, il se renomme sept fois — le produit s'est déjà
 * appelé Upfac, et c'est exactement ce qui a coûté cette passe-là.
 */
export const NOM = 'Haicademy'

/** La même chose en minuscules, pour ce qui n'accepte pas de majuscule. */
export const NOM_MINUSCULE = NOM.toLowerCase()
